import classNames from 'classnames'
import { Star } from './star'

export default function AgentReviewStar({
  className,
  score,
  count
}) {

  return (
    <div className={classNames('flex items-center', className)}>
      <div className='flex items-center bg-primary-light px-10 h-22 rounded-4xl border border-primary'>
        <span className='mr-8'>{score}</span>
        <Star value={100}></Star>
      </div>
      <div className='ml-4 text-primary text-sm'>{count} reviews</div>
    </div>
  )
}

export function AgentCardReviewStar({
  className,
  score,
  count
}) {
  return (
    <div className={classNames('flex items-center text-primary text-sm', className)}>
      <div className='flex items-center'>
        <Star value={100} size={12}></Star>
        <span className='ml-2'>{score}</span>
      </div>
      <div className='underline before:inline-block before:mx-6 before:align-middle before:w-4 before:h-4 before:bg-primary before:rounded-half'>
        {
          count
            ? `${count} reviews`
            : 'no review available'
        }
      </div>
    </div>
  )
}